module.exports = __webpack_public_path__ + "static/media/C_S03.5e1c3b17.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/BLUE/C_S03.png
// module id = 77
// module chunks = 0